import {ReactComponent as Icon} from '@image/icon_protractor.svg';

const IconProtractor = () => {
    return   <Icon />;
};

export default IconProtractor;